// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy_container__24e_W","wrapper":"Privacy_wrapper__yMxoG","btn":"Privacy_btn__2Jqsl"};